'use client';

import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';

function SkeletonBlock({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-[10px] bg-gray-200 ${className}`} />;
}

export default function ComplianceSkeleton() {
  return (
    <DocumentPageShell
      eyebrow="Corporate"
      title="Compliance"
      subtitle={<SkeletonBlock className="h-5 w-3/4" />}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <SkeletonBlock className="h-28 rounded-2xl" />
        <SkeletonBlock className="h-28 rounded-2xl" />
      </div>
      <div className="mt-6 overflow-hidden rounded-2xl border border-[#e4e4e4] bg-white shadow-sm sm:mt-8">
        <div className="flex gap-4 border-b border-[#e4e4e4] bg-[#faf9f7] px-5 py-4">
          <SkeletonBlock className="h-6 w-24" />
          <SkeletonBlock className="h-6 w-32" />
          <SkeletonBlock className="h-6 w-28" />
        </div>
        <div className="grid grid-cols-1 gap-4 p-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:p-6 md:p-8">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <SkeletonBlock key={i} className="h-[220px] rounded-2xl" />
          ))}
        </div>
      </div>
    </DocumentPageShell>
  );
}
